export const tipoProfissionalSaude = {
  1: "Médico",
  2: "Secretário",
  3: "Administrador",
  4: "Tecnico",
};
